import { useState } from 'react';
import { devLogin } from '../boot';
import { reportError, useT } from '../i18n';

/**
 * Shown only outside Telegram. The server signs test initData with the bot token (DEV_AUTH_ENABLED, never in
 * production), so local players go through exactly the same login as real Telegram users.
 */
export function DevLogin() {
  const t = useT();
  const [telegramId, setTelegramId] = useState(() =>
    String(100_000_000 + Math.floor(Math.random() * 899_999_999)),
  );
  const [name, setName] = useState('Tester');
  const [lang, setLang] = useState('en');
  const [busy, setBusy] = useState(false);
  const [unavailable, setUnavailable] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await devLogin({
        telegramId: Number(telegramId),
        firstName: name.trim() || 'Tester',
        languageCode: lang,
      });
    } catch (err) {
      if ((err as { status?: number }).status === 404) setUnavailable(true);
      else reportError(err);
    } finally {
      setBusy(false);
    }
  };

  if (unavailable) {
    return (
      <div className="center">
        <p className="subtitle">{t('errors.INIT_DATA_INVALID')}</p>
      </div>
    );
  }
  return (
    <div className="screen" style={{ justifyContent: 'center' }}>
      <div style={{ fontSize: 56, textAlign: 'center' }}>🍾</div>
      <h1 className="title" style={{ textAlign: 'center' }}>
        {t('app.title')}
      </h1>
      <p className="subtitle" style={{ textAlign: 'center' }}>
        Development login — outside Telegram
      </p>
      <div className="card" style={{ display: 'grid', gap: 12 }}>
        <div className="field">
          <label htmlFor="dev-id">Telegram id</label>
          <input
            id="dev-id"
            className="input"
            inputMode="numeric"
            value={telegramId}
            onChange={(e) => setTelegramId(e.target.value.replace(/\D/g, ''))}
          />
        </div>
        <div className="field">
          <label htmlFor="dev-name">First name</label>
          <input
            id="dev-name"
            className="input"
            value={name}
            maxLength={32}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="field">
          <label htmlFor="dev-lang">{t('onboarding.language')}</label>
          <select id="dev-lang" className="input" value={lang} onChange={(e) => setLang(e.target.value)}>
            <option value="en">English</option>
            <option value="ru">Русский</option>
            <option value="uz">Oʻzbekcha</option>
          </select>
        </div>
        <button
          className="btn btn-primary btn-block"
          disabled={busy || !telegramId}
          onClick={() => void submit()}
        >
          {t('onboarding.start')}
        </button>
      </div>
    </div>
  );
}
